
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    DialogIndex: Number,
    DialogData: { default: () => { return {} }, type: Object as PropType<DialogData> }
  },
  data () {
    return {
      PayrollItemType: [] as Array<PayrollItemType>,
      Employees: [] as Array<Employee>,
      Positions: [] as Array<Position>,
      OriginalData: {} as any,
      Saving: false,
      Loading: [],
      ErrorsVisibilty: false,
      DialogMapper: [
        { Path: 'Reason', Res: 'D_PayrollItem_Reason' },
        { Path: 'Fixed', Res: 'D_PayrollItem_Fixed' },
        { Path: 'Percentage', Res: 'D_PayrollItem_Percentage' },
        { Path: ['Employee', 'Name'], Res: 'D_PayrollItem_Employee', ValuePath: 'ID', SavingPath: 'EmployeeID' },
        { Path: ['Position', 'Name'], Res: 'D_PayrollItem_Position', ValuePath: 'ID', SavingPath: 'PositionID' },
        { Path: ['Type', 'Name'], Res: 'D_PayrollItem_Type', ValuePath: 'ID', SavingPath: 'PayrollItemTypeID' }
      ] as Array<DialogMapperObject>
    }
  },
  methods: {
    ReadPayrollItemType () {
      this.Get('HR_PayrollItemTypes').then(response => {
        this.PayrollItemType = response
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading PayrollItem Type'
        this.OpenDialog('Error_Dialog', 'Error', error)
      })
    },
    ReadEmployees () {
      this.Get('HR_Employees').then(response => {
        this.Employees = response
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Employees'
        this.OpenDialog('Error_Dialog', 'Error', error)
      })
    },
    ReadPositions () {
      this.Get('HR_Positions').then(response => {
        this.Positions = response
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Positions'
        this.OpenDialog('Error_Dialog', 'Error', error)
      })
    },
    SaveData () {
      this.SaveDialogData({
        DialogMapper: this.DialogMapper,
        Parentthis: this,
        PostAPI: 'HR_PayrollItem',
        OriginalData: this.OriginalData,
        PatchAPI: 'HR_PayrollItem',
        Editing: this.DialogData.Editing,
        PatchQuery: '/' + this.DialogData?.Data?.ID
      })
    },
    DataSaved () {
      this.Saving = false
      this.$router.go(-1)
    }
  },
  mounted () {
    this.ReadPayrollItemType()
    this.ReadEmployees()
    this.ReadPositions()
    const Dialog = document.getElementById('CookiesDialog_' + this.DialogIndex)
    if (Dialog) {
      window.scrollTo(0, Dialog.offsetTop - 60)
    }
    if (this.DialogData.Editing) {
      this.OriginalData = this.CookiesDialogInitiator(this.DialogMapper, this.DialogData.Data)
      this.Console(this.OriginalData)
    }
  },
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        this.ReadPayrollItemType()
        this.ReadEmployees()
        this.ReadPositions()
      }
    }
  }
})
